import { yup } from '@guiker/yup-util'

export const createPayoutWithdrawalSchema = yup.object({
  payoutMethodId: yup.string().required(),
  amount: yup.number().positive().required(),
})
